import { render, staticRenderFns } from "./TransferCharges.vue?vue&type=template&id=8a6ce748"
import script from "./TransferCharges.vue?vue&type=script&lang=js"
export * from "./TransferCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports